import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import './About.css';
import image from '../../images/nasirul01.png';
import { Link } from 'react-router-dom';

const About = () => {
    return (
        <div className="about" id="About">
            <Container className="pt-5">
                <Row className="g-4">
                    <Col sm={12} md={5} lg={5} className="">
                        <img width="100%" height="100%" src={image} alt="images" />
                    </Col>
                    <Col sm={12} md={7} lg={7} className="text-start">
                        <h1 className="text-white mb-4">About Me</h1>
                        <p>I am Nasirul Islam. I am a very dedicated and enthusiastic Front End Web Developer. Playing with Code Editor is my passion. I always like to explore new technologies.</p>
                        <p>I am also a junior MERN Stack Developer. Using MERN stack Technology, I build some projects last month.</p>
                        <div className="">
                            <div className="text-white">
                                {/* <Link to="/">Main Skill</Link>
                                <Link to="/">Main Skill</Link>
                                <Link to="/">Main Skill</Link> */}
                            </div>
                            <div className="">
                                {/* <Outlet /> */}
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div >
    );
};

export default About;